import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import StrConcat from '@/components/StrConcat'
import PicToWebp from '@/components/PicToWebp'
import AiNcmj from '@/components/AiNcmj'
import ChatRoom from '@/components/ChatRoom'
import NetworkStatus from '@/components/NetworkStatus'
import SqlToGoStruct from '@/components/SqlToGoStruct'
import Salary from '@/components/Salary.vue'
import AiPet from '@/components/AiPet.vue'
import AiToy from '@/components/AiToy.vue'
import TravelXuebi from '@/components/TravelXuebi.vue'

Vue.use(Router)

export default new Router({
  mode: 'history', // 设置路由模式为history
  scrollBehavior() {
    // 总是滚动到顶部
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/str_concat',
      name: 'StrConcat',
      component: StrConcat
    },
    {
      path: '/pic_to_webp',
      name: 'PicToWebp',
      component: PicToWebp
    },
    {
      path: '/ai_ncmj',
      name: 'AiNcmj',
      component: AiNcmj
    },
    {
      path: '/chat_room',
      name: 'ChatRoom',
      component: ChatRoom
    },
    {
      path: '/network_status',
      name: 'Network_status',
      component: NetworkStatus
    },
    {
      path: '/sql_to_gostruct',
      name: 'SqlToGoStruct',
      component: SqlToGoStruct
    },
    {
      path: '/salary',
      name: 'Salary',
      component: Salary
    },
    {
      path: '/ai_pet',
      name: 'AiPet',
      component: AiPet
    },
    {
      path: '/ai_toy',
      name: 'AiToy',
      component: AiToy
    },
    {
      path: '/xuebi_travel',
      name: 'TravelXuebi',
      component: TravelXuebi
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js